export const APP_NAME = 'Priority Matrix'
